import {Box, CircularProgress, LinearProgress, Typography} from "@mui/material";
import {LogoCardView} from "./LogoCardView";
import React from "react";
import {theme} from "../../app/theme";

export interface LoadingPageViewProps {
    message?: string;
}

export const LoadingPageView: React.FC<LoadingPageViewProps> = ({ message = "Loading..." }) => {

    return (
        <LogoCardView>
            <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: 2 }}>
                <CircularProgress size={48} sx={{color: theme.palette.secondary.dark}}/>
                <Typography variant="h6" color="text.secondary">
                    {message}
                </Typography>
                <LinearProgress sx={{ width: 200, backgroundColor: theme.palette.secondary.dark }} />
            </Box>
        </LogoCardView>
    );
};